"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.sync = exports.scanAccounts = void 0;
var wallet_btc_1 = require("./wallet-btc");
var bignumber_js_1 = require("bignumber.js");
var hw_app_btc_1 = __importDefault(require("@ledgerhq/hw-app-btc"));
var logs_1 = require("@ledgerhq/logs");
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var jsHelpers_1 = require("../../bridge/jsHelpers");
var account_1 = require("../../account");
var derivation_1 = require("../../derivation");
var logic_1 = require("./logic");
var wallet_btc_2 = __importDefault(require("./wallet-btc"));
var hw_getAddress_1 = require("./hw-getAddress");
var logic_2 = require("./logic");
var index_1 = require("../../account/index");
var performance_1 = require("../../performance");
// Map LL's DerivationMode to wallet-btc's
var toWalletDerivationMode = function (mode) {
    if ((0, derivation_1.isTaprootDerivationMode)(mode)) {
        return wallet_btc_1.DerivationModes.TAPROOT;
    }
    if ((0, derivation_1.isNativeSegwitDerivationMode)(mode)) {
        return wallet_btc_1.DerivationModes.NATIVE_SEGWIT;
    }
    if ((0, derivation_1.isSegwitDerivationMode)(mode)) {
        return wallet_btc_1.DerivationModes.SEGWIT;
    }
    return wallet_btc_1.DerivationModes.LEGACY;
};
// Map LL's currency ID to wallet-btc's Account.params.network
var toWalletNetwork = function (currencyId) {
    return (0, cryptoassets_1.getCryptoCurrencyById)(currencyId).isTestnetFor ? "testnet" : "mainnet";
};
// Map wallet-btc's Output to LL's BitcoinOutput
var fromWalletUtxo = function (utxo, changeAddresses) {
    return {
        hash: utxo.output_hash,
        outputIndex: utxo.output_index,
        blockHeight: utxo.block_height,
        address: utxo.address,
        value: new bignumber_js_1.BigNumber(utxo.value),
        rbf: utxo.rbf,
        isChange: changeAddresses.has(utxo.address)
    };
};
// wallet-btc limitation: returns all transactions twice (for each side of the tx)
// so we need to deduplicate them...
var deduplicateOperations = function (operations) {
    var e_1, _a;
    var seen = {};
    var out = [];
    var j = 0;
    try {
        for (var operations_1 = __values(operations), operations_1_1 = operations_1.next(); !operations_1_1.done; operations_1_1 = operations_1.next()) {
            var operation = operations_1_1.value;
            if (operation) {
                if (seen[operation.id] !== 1) {
                    seen[operation.id] = 1;
                    out[j++] = operation;
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (operations_1_1 && !operations_1_1.done && (_a = operations_1["return"])) _a.call(operations_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return out;
};
var getAccountShape = function (info) { return __awaiter(void 0, void 0, void 0, function () {
    var span, transport, currency, index, derivationPath, derivationMode, initialAccount, rootPath, accountPath, paramXpub, generatedXpub, bitcoinLikeInfo, btc, xpubVersion, xpub, accountId, walletNetwork, walletDerivationMode, walletAccount, _a, oldOperations, balance, currentBlock, blockHeight, transactions, accountAddresses, accountAddressesWithInfo, changeAddresses, changeAddressesWithInfo, newOperations, newUniqueOperations, operations, rawUtxos, utxos;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                transport = info.transport, currency = info.currency, index = info.index, derivationPath = info.derivationPath, derivationMode = info.derivationMode, initialAccount = info.initialAccount;
                rootPath = derivationPath.split("/", 2).join("/");
                accountPath = "".concat(rootPath, "/").concat(index, "'");
                paramXpub = initialAccount
                    ? (0, index_1.decodeAccountId)(initialAccount.id).xpubOrAddress
                    : undefined;
                if (!!paramXpub) return [3 /*break*/, 2];
                // Xpub not provided, generate it using the hwapp
                if (!transport) {
                    // hwapp not provided
                    throw new Error("hwapp required to generate the xpub");
                }
                bitcoinLikeInfo = currency.bitcoinLikeInfo;
                btc = new hw_app_btc_1["default"]({ transport: transport, currency: currency.id });
                xpubVersion = bitcoinLikeInfo.XPUBVersion;
                return [4 /*yield*/, btc.getWalletXpub({ path: accountPath, xpubVersion: xpubVersion })];
            case 1:
                generatedXpub = _c.sent();
                _c.label = 2;
            case 2:
                xpub = paramXpub || generatedXpub;
                accountId = (0, account_1.encodeAccountId)({
                    type: "js",
                    version: "2",
                    currencyId: currency.id,
                    xpubOrAddress: xpub,
                    derivationMode: derivationMode
                });
                walletNetwork = toWalletNetwork(currency.id);
                walletDerivationMode = toWalletDerivationMode(derivationMode);
                span = (0, performance_1.startSpan)("sync", "generateAccount");
                _a = ((_b = initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.bitcoinResources) === null || _b === void 0 ? void 0 : _b.walletAccount);
                if (_a) return [3 /*break*/, 4];
                return [4 /*yield*/, wallet_btc_2["default"].generateAccount({
                        xpub: xpub,
                        path: rootPath,
                        index: index,
                        currency: currency.id,
                        network: walletNetwork,
                        derivationMode: walletDerivationMode
                    }, currency)];
            case 3:
                _a = (_c.sent());
                _c.label = 4;
            case 4:
                walletAccount = _a;
                span.finish();
                oldOperations = (initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.operations) || [];
                return [4 /*yield*/, wallet_btc_2["default"].syncAccount(walletAccount)];
            case 5:
                _c.sent();
                return [4 /*yield*/, wallet_btc_2["default"].getAccountBalance(walletAccount)];
            case 6:
                balance = _c.sent();
                return [4 /*yield*/, walletAccount.xpub.explorer.getCurrentBlock()];
            case 7:
                currentBlock = _c.sent();
                blockHeight = currentBlock === null || currentBlock === void 0 ? void 0 : currentBlock.height;
                span = (0, performance_1.startSpan)("sync", "getAccountTransactions");
                return [4 /*yield*/, wallet_btc_2["default"].getAccountTransactions(walletAccount)];
            case 8:
                transactions = (_c.sent()).txs;
                span.finish();
                span = (0, performance_1.startSpan)("sync", "getXpubAddresses");
                accountAddresses = new Set();
                return [4 /*yield*/, walletAccount.xpub.getXpubAddresses()];
            case 9:
                accountAddressesWithInfo = _c.sent();
                accountAddressesWithInfo.forEach(function (a) { return accountAddresses.add(a.address); });
                span.finish();
                span = (0, performance_1.startSpan)("sync", "getUniquesAddresses");
                changeAddresses = new Set();
                return [4 /*yield*/, walletAccount.xpub.storage.getUniquesAddresses({
                        account: 1
                    })];
            case 10:
                changeAddressesWithInfo = _c.sent();
                changeAddressesWithInfo.forEach(function (a) { return changeAddresses.add(a.address); });
                span.finish();
                span = (0, performance_1.startSpan)("sync", "mapTxToOperations");
                newOperations = transactions === null || transactions === void 0 ? void 0 : transactions.map(function (tx) {
                    return (0, logic_2.mapTxToOperations)(tx, currency.id, accountId, accountAddresses, changeAddresses);
                }).flat();
                span.finish();
                span = (0, performance_1.startSpan)("sync", "unify operations");
                newUniqueOperations = deduplicateOperations(newOperations);
                operations = (0, jsHelpers_1.mergeOps)(oldOperations, newUniqueOperations);
                span.finish();
                span = (0, performance_1.startSpan)("sync", "gather utxos");
                return [4 /*yield*/, wallet_btc_2["default"].getAccountUnspentUtxos(walletAccount)];
            case 11:
                rawUtxos = _c.sent();
                utxos = rawUtxos.map(function (utxo) { return fromWalletUtxo(utxo, changeAddresses); });
                span.finish();
                return [2 /*return*/, {
                        id: accountId,
                        xpub: xpub,
                        balance: balance,
                        spendableBalance: balance,
                        operations: operations,
                        operationsCount: operations.length,
                        freshAddress: walletAccount.xpub.freshAddress,
                        freshAddressPath: "".concat(accountPath, "/0/").concat(walletAccount.xpub.freshAddressIndex),
                        blockHeight: blockHeight,
                        bitcoinResources: {
                            utxos: utxos,
                            walletAccount: walletAccount
                        }
                    }];
        }
    });
}); };
var postSync = function (initial, synced) {
    var _a;
    (0, logs_1.log)("bitcoin/postSync", "bitcoinResources");
    var perCoin = logic_1.perCoinLogic[synced.currency.id];
    var syncedBtc = synced;
    if (perCoin) {
        var postBuildBitcoinResources = perCoin.postBuildBitcoinResources, syncReplaceAddress_1 = perCoin.syncReplaceAddress;
        if (postBuildBitcoinResources) {
            syncedBtc.bitcoinResources = postBuildBitcoinResources(syncedBtc, syncedBtc.bitcoinResources);
        }
        if (syncReplaceAddress_1) {
            syncedBtc.freshAddress = syncReplaceAddress_1(syncedBtc.freshAddress);
            syncedBtc.freshAddresses = syncedBtc.freshAddresses.map(function (a) { return (__assign(__assign({}, a), { address: syncReplaceAddress_1(a.address) })); });
            if (syncedBtc.bitcoinResources) {
                syncedBtc.bitcoinResources.utxos =
                    (_a = syncedBtc.bitcoinResources) === null || _a === void 0 ? void 0 : _a.utxos.map(function (u) { return (__assign(__assign({}, u), { address: u.address && syncReplaceAddress_1(u.address) })); });
            }
        }
    }
    (0, logs_1.log)("bitcoin/postSync", "bitcoinResources DONE");
    return syncedBtc;
};
var getAddressFn = function (transport) {
    return function (opts) { return (0, hw_getAddress_1.getAddress)(transport, opts); };
};
exports.scanAccounts = (0, jsHelpers_1.makeScanAccounts)({
    getAccountShape: getAccountShape,
    getAddressFn: getAddressFn
});
exports.sync = (0, jsHelpers_1.makeSync)({ getAccountShape: getAccountShape, postSync: postSync });
//# sourceMappingURL=js-synchronisation.js.map